import { render, staticRenderFns } from "./CustomEditor.vue?vue&type=template&id=fd94e882&scoped=true"
import script from "./CustomEditor.vue?vue&type=script&lang=js"
export * from "./CustomEditor.vue?vue&type=script&lang=js"
import style0 from "./CustomEditor.vue?vue&type=style&index=0&id=fd94e882&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd94e882",
  null
  
)

export default component.exports